//State
export default function(state=null,action){
  switch (action.type) {
    case "DELIVERY_DETAILS":
        return action.payload;
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/get_delivery_details.js